import {
  SWITCH_PLATFORM,
  SWITCH_PLATFORM_ERROR,
  SWITCH_PLATFORM_SUCCESS,
  UPDATE_CREDIT_USERTYPE,
  UPDATE_CREDIT_USERTYPE_ERROR,
  UPDATE_CREDIT_USERTYPE_SUCCESS,
} from "./actionTypes";

const initialState = {
  loading: false,
  switchedPlatform: null,
  switchePlatformErr: null,
  updateCreditUsertype: null,
  updateCreditUsertypeErr: null,
};

const switchPlatform = ( state=initialState, action ) => {
  switch (action.type) {
    case SWITCH_PLATFORM:
    case UPDATE_CREDIT_USERTYPE:
      state = {
        ...state,
        loading: true
      }
      break;
      
    case SWITCH_PLATFORM_SUCCESS:
      state = {
        ...state,
        loading: false,
        switchedPlatform: action.payload,
        switchePlatformErr: null
      }
      break;

    case SWITCH_PLATFORM_ERROR:
      state = {
        ...state,
        loading: false,
        switchedPlatform: null,
        switchePlatformErr: action.payload
      }
      break;

    case UPDATE_CREDIT_USERTYPE_SUCCESS:
      state = {
        ...state,
        loading: false,
        updateCreditUsertype: action.payload,
        updateCreditUsertypeErr: null
      }
      break;

    case UPDATE_CREDIT_USERTYPE_ERROR:
      state = {
        ...state,
        loading: false,
        updateCreditUsertype: null,
        updateCreditUsertypeErr: action.payload
      }
      break;

    default:
      state = { ...state }
      break;
  };

  return state;
};

export default switchPlatform;